<div class="container">
  <div class="dashboard">
    <div *ngIf="emails?.length == 0 && !isLoading" style="text-align: center;padding: 60px;">
      <h4 style="margin-bottom: 20px;">You don't have any emails yet</h4>
    </div>

    <loader [loading]="isLoading"></loader>

    <div class="wrapper" *ngIf="emails?.length > 0 && !isLoading">
      <div class="report-header">
        <div class="row">
          <div class="col">
            <label>Subject</label>
          </div>

          <div class="col-sm-3 col-md-3">
            <label>Sent by User</label>
          </div>

          <div class="col-sm-3 col-md-3">
            <label>Type</label>
          </div>

          <div class="col-sm-2 col-md-2">
            <label>Date/Time</label>
          </div>
        </div>
      </div>

      <div class="reports-data">
        <div class="report" *ngFor="let email of emails; let i = index">
          <div class="row" (click)="gotoEmail(email)">
            <div class="column col company">
              <div class="company-info">
                <div class="company-name">
                  {{email.SUBJECT}}
                </div>
              </div>
            </div>

            <div class="column col-sm-3 col-md-3">
              <span *ngIf="email.USER">{{email?.USER.getName()}}</span>
            </div>

            <div class="column col-md-3 col-sm-3">
              <div [ngSwitch]="email.LETTER_TYPE">
                <div *ngSwitchCase="LetterType.INITIAL_EMAIL">Initial Email</div>
                <div *ngSwitchCase="LetterType.ENGAGEMENT_LETTER">Engagement Letter</div>
              </div>
            </div>

            <div class="column col-md-2 col-sm-2">
              {{email.DATE | date: 'MM/dd/yyyy hh:mm a'}}
            </div>
          </div>
        </div>
      </div>
    </div>
</div>

  <div style="width:100%;text-align:right;" class="pagination-wrapper" *ngIf="totalItems > 20 ">
    <pagination [totalItems]="totalItems" [itemsPerPage]="20" [(ngModel)]="currentPage" [maxSize]="5" [boundaryLinks]="true"
                [rotate]="false" (pageChanged)="pageChanged($event)" class="pagination-sm"></pagination>
  </div>
</div>
